/**
 * Enum for supported entity types in the audit system
 * Add new entity types here as they are implemented
 */
export enum EntityType {
	CONTRACTOR = 'Contractor',
	CONTRACT_TEMPLATE = 'ContractTemplate',
	USER = 'User',
	// Add other entity types as needed:
	// CLIENT = 'Client',
	// CONTRACT = 'Contract'
}

/**
 * Type for audit actions
 */
export type AuditAction = 'CREATE' | 'UPDATE' | 'DELETE'

/**
 * Helper function to get all entity type values
 */
export function getAllEntityTypes(): string[] {
	return Object.values(EntityType)
}

/**
 * Helper function to check if a string is a valid entity type
 */
export function isValidEntityType(value: string): value is EntityType {
	return Object.values(EntityType).includes(value as EntityType)
} 